import { matchPath } from "react-router-dom";

export default function matchRoute(pathname, route, { exact = false } = {}) {
  const match = matchPath({ path: route.path, end: exact }, pathname);
  if (!match) return null;

  if (route.checkParams && !route.checkParams(match.params)) return null;
  return match.params;
}
